<template>
  <v-select
    class="tema-eixo-combo"
    id="temas-select"
    v-model="editValue.eixoId"
    item-text="nome"
    item-name="nome"
    item-value="eixoId"
    :items="eixos"
    label="Eixo"
    placeholder="Eixo"
    v-on:change="$emit('onChange')"
    :disabled="disabled"
  >
    <template slot="no-data"> Nenhum Eixo </template>
  </v-select>
</template>

<script>
import { temaAPI } from '../API/temaAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppEixoCombobox',
  props: {
    editValue: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false }
  },
  mounted () {
    this.loadEixos()
  },
  methods: {
    ...mapActions(['setLoading']),

    loadEixos () {
      temaAPI
        .listEixo()
        .then((resp) => {
          this.eixos = resp.data
        })
        .catch((resp) => {
          this.$notification.error('Erro ao obter Eixos')
        })
    }
  },
  data () {
    return {
      eixos: []
    }
  }
}
</script>

<style scoped>
.tema-eixo-combo{
      padding: 0 24px 20px;
}
</style>
